import { AxiosResponse } from "axios";
import SDKConfiguraitonModel from "../Configurator/Models/SDKConfiguraitonModel";
import {requestChunkBuild, setBaseUrl, transformIdsToBeUnique} from "../Global/Helper";
import IdMappingModel from "../IdMapping/Models/IdMappingModel";
import Https from "./Https";

const types: any = {
    player: 'players',
    team: 'teams',
    homeTeam: 'teams',
    awayTeam: 'teams',
    country: 'countries',
    competition: 'competitions',
    match: 'matches'
}

export default class IdMappingHttps extends Https {
    constructor(config: SDKConfiguraitonModel) {
        super(config, setBaseUrl(config.environment, "idMapping"));
    }

    getEntityById = (type: string, id: string): AxiosResponse<any> => {
        try {
            //@ts-ignore
            return this.instance.get(`/football${this.apiSignInUrl}&input_provider=${config.idSchema}&${types[type]}=${id}`);
        } catch (e) {
            console.warn(`There was a problem with id mapping request for the following id:${id}`, e);
            throw e.response;
        }
    };


    getEntityByIdAndSchema = (type: string, id: string, schemaId: string): AxiosResponse<any> => {
        try {
            //@ts-ignore
            return this.instance.get(`/football${this.apiSignInUrl}&input_provider=${schemaId}&${types[type]}=${id}`);
        } catch (e) {
            console.warn(`There was a problem with id mapping request for the following id:${id}`, e);
            throw e.response;
        }
    };

    getEntityIdsByIdsAndSchema = (type: string, ids: string[], schemaId: string) => {
        try {
            return this.instance.get(`/football${this.apiSignInUrl}&input_provider=${schemaId}&${types[type]}=${ids.join(',')}`);
        } catch (e) {
            console.warn(`There was a problem with id mapping request for the following ids:${ids.join(",")}`, e);
            throw e.response;
        }
    };

    public getEntitiesByIds = (type: string, ids: string[], idSchema: string) => {
        ids.sort((a: string, b: string) => a.localeCompare(b));
        const requestChunks = requestChunkBuild(ids);
        const requests = requestChunks.map((chunk: any[]) => {
            try {
                //@ts-ignore
                return this.instance.get(`/football${this.apiSignInUrl}&input_provider=${idSchema}&${types[type]}=${chunk.join(',')}`);
            } catch (e) {
                const fansUnitedException = this.transformAxiosErrorToFansUnitedException(e);
                console.warn(`There was a problem with id mapping request for the following ids:${chunk.join(",")}`, fansUnitedException);
                throw fansUnitedException.response;
            }
        });

        return Promise.all(requests).then((responses: any[]) => {

            const result: any[] = [];

            responses.forEach((resp: any) => {
                result.push(...resp.data.data);
            });

            return result;
        })
    };

    /**
     * API has set a maximum size for url - it can have in total 250 ids. Before making request to API (Id Mapping), the ids are combined and if they are more than 249
     * they are splited in separated chunk arrays. Then it makes verification for the chunks:
     * - For more than one chunk, we create new object @var newIdsObj with type properties and value ids. Then with the new object we get the keys and values and make a request.
     * Same goes for rest of the chunks.
     * - For only one chunk we use the @var entityIdsObj and make a single request with all types and ids.
     * @param entityIdsObj
     * @param schemaId  -- Optional
     * @returns Entities ids
     */

    public getEntitiesByIdObjs = async (entityIdsObj: any, schemaId?: string): Promise<any[]> => {
        let allIds: string[] = [];
        let entityMaxLengthIdsObj: any = {};
        let results: any[] = [];


        Object.keys(entityIdsObj).forEach((key: string) => {
            allIds.push.apply(allIds, entityIdsObj[key]);
        });

        const uniqueIds = transformIdsToBeUnique(allIds);
        const requestChunks = requestChunkBuild(uniqueIds);

        for (const chunk of requestChunks) {
            let maxUrlLength = "";
            Object.keys(entityIdsObj).forEach((key: string) => {
                entityMaxLengthIdsObj[key] = [];
                const intersection = chunk.filter((id:string) => entityIdsObj[key].includes(id));
                if (intersection && intersection.length > 0) {
                    entityMaxLengthIdsObj[key] = intersection;
                }
            })

            Object.keys(entityMaxLengthIdsObj).forEach((key: string) => {
                if (entityMaxLengthIdsObj[key].length > 0) {
                    entityMaxLengthIdsObj[key].sort((a: string, b: string) => a.localeCompare(b));
                    maxUrlLength += '&';
                    maxUrlLength += `${types[key]}=${entityMaxLengthIdsObj[key].join(",")}`;
                }
            });

            if (maxUrlLength && maxUrlLength.length > 0) {
                try {
                    const response = await this.instance.get(`/football${this.apiSignInUrl}&input_provider=${schemaId ? schemaId : 'native'}${maxUrlLength}`);

                    results.push(response.data.data);
                } catch (e) {
                    const fansUnitedException = this.transformAxiosErrorToFansUnitedException(e);
                    console.warn('There was a problem with id mapping request', fansUnitedException);
                    throw fansUnitedException.response;
                }
            } else {
                results.push([]);
            }
        }

        const response = Array.prototype.concat.apply([], results);
        return response;
    };

    public getTopEntities = async (): Promise<IdMappingModel[]> => {
        try {
            const response = await this.instance.get(`/football/top${this.apiSignInUrl}`);

            return response.data.data;
        } catch (e) {
            const fansUnitedException = this.transformAxiosErrorToFansUnitedException(e);
            console.warn('There was a problem with top id mappings request', fansUnitedException);
            throw fansUnitedException.response;
        }
    };

}
